import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAiNotetakerActive = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.83333 17.5C5.83333 15.659 4.34095 14.1666 2.5 14.1666C4.34095 14.1666 5.83333 12.6743 5.83333 10.8333C5.83333 12.6743 7.32572 14.1666 9.16667 14.1666C7.32572 14.1666 5.83333 15.659 5.83333 17.5Z",
			fill: "#0517F8",
			stroke: "#0517F8",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.6665 17.5H14.5832C15.7338 17.5 16.6665 16.5673 16.6665 15.4167V6.97639C16.6665 6.31335 16.4031 5.67747 15.9343 5.20862L13.9579 3.23223C13.489 2.76339 12.8532 2.5 12.1901 2.5H6.24984C5.09924 2.5 4.1665 3.43274 4.1665 4.58333V7.5",
			stroke: "#0517F8",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.647 6.66664H13.75C13.0596 6.66664 12.5 6.10699 12.5 5.41664V2.51965",
			stroke: "#0517F8",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgAiNotetakerActive;
